/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:
// var componentRequireContext = require.context("components/components", false)
// var ReactRailsUJS = require("react_ujs")
// ReactRailsUJS.useContext(componentRequireContext)


import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reduxApp from '../components/reducers'

import SummaryApp from '../components/components/SummaryApp'
import ReturnApp from '../components/components/ReturnApp'
import CompanyLogo from '../components/components/CompanyLogo'

let store = createStore(reduxApp, applyMiddleware(
    thunkMiddleware // lets us dispatch() functions
  ))

render(
  <Provider store={store}>
    <CompanyLogo />
  </Provider>,
  document.querySelector('#company_logo')
)

render(
  <Provider store={store}>
    <SummaryApp />
  </Provider>,
  document.querySelector('#summary_app')
)

render(
  <Provider store={store}>
    <ReturnApp />
  </Provider>,
  document.querySelector('#return_app')
)


// WEBPACK FOOTER //
// ./app/javascript/packs/application.js